import './index.scss'
import { Controller as BaseController } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'

export class Controller extends BaseController {
  static targets = ['flyout', 'content', 'loadingIndicator'];

  connect() {
    useDispatch(this)
    useBusItem(this, { addToBus: true })
  }

  load(url, requestOptions = {}) {
    return fetch(url, requestOptions)
      .then(response => response.text())
      .then((html) => {
        this.contentTarget.innerHTML = html
      })
      .catch(() => {
        this.contentTarget.innerHTML = "<h2 class='flyout__error'>Failure loading Entity</h2>"
      })
  }

  openFlyoutFromCard(event) {
    if (this.blocksFlyout(event.target)) return

    const buttonId = event.currentTarget.getAttribute('data-entity-card-id')

    if (!buttonId) return

    const element = buttonId + '-view-details-button'

    const button = document.getElementById(element)

    if (event.target !== button) {
      button.click()
    }
  }

  triggerFlyout(event) {
    if (this.blocksFlyout(event.target)) return

    event.preventDefault()
    event = event.currentTarget

    const url = event.getAttribute('data-url')

    this.dispatch('open')

    if (url && url !== this.flyoutTarget.dataset.url) {
      const requestOpts = {
        method: event.getAttribute('data-request-method') || 'GET'
      }

      if (requestOpts.method === 'POST') {
        requestOpts.body = event.getAttribute('data-request-payload') || {}
        requestOpts.headers = { 'Content-Type': 'application/json' }
      }

      // Clear out the current Flyout content, and show the loading indicator (again)
      this.reset()
      // Capture the current Entity ID in a data attribute on the Flyout itself
      this.flyoutTarget.setAttribute('data-url', url)
      // Let assistive technologies know that the area is loading
      this.flyoutTarget.setAttribute('aria-busy', 'true')
      //
      this.load(url, requestOpts)
        .then(() => {
          // Let assistive technologies know that the area is no longer loading
          this.flyoutTarget.setAttribute('aria-busy', 'false')
          this.loadingIndicatorTarget.setAttribute('hidden', '')
          this.flyoutTarget.querySelector('main').setAttribute('data-url', url.split('?')[0])
        })
    }
  }

  reloadWhenTriggered() {
    // Clears the current URL so that, next time when opening, it will be forced to reload the content.
    this.flyoutTarget.setAttribute('data-url', '')
  }

  reset() {
    this.contentTarget.innerHTML = ''
    this.loadingIndicatorTarget.removeAttribute('hidden')
  }

  blocksFlyout(element) {
    const flyoutAreas = this.element.querySelectorAll('[data-trigger-flyout="true"]')

    return [...flyoutAreas].every((area) => {
      const blockingNodeName = this.isBlockingNode(element)
      if (!blockingNodeName && area.contains(element)) {
        return false
      }

      return true // blocks flyout trigger
    })
  }

  isBlockingNode(element) {
    return (['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'LABEL'].includes(element.nodeName) &&
      !element.hasAttribute('data-trigger-flyout')) ||
      this.hasParentClass(element, 'no-flyout') ||
      this.isVisible(document.getElementsByClassName('c-select-multiple__menu c-select-multiple__menu--active')[0])
  }

  computedStyle(element) {
    return window.getComputedStyle ? window.getComputedStyle(element, null) : element.currentStyle
  }

  isVisible(element) {
    if (!element) return
    return !(element.offsetWidth === 0 && element.offsetHeight === 0) && this.computedStyle(element).visibility !== 'hidden'
  }

  hasParentClass(child, classname) {
    if (child.className.split instanceof Function && child.className.split(' ').indexOf(classname) >= 0) return true
    try {
      // Throws TypeError if child doesn't have parent any more
      return child.parentNode && this.hasParentClass(child.parentNode, classname)
    } catch (TypeError) {
      return false
    }
  }
}
